/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", init);

function init() {
  setupBannerDates();
  setupCustomAnnouncementBars();
  setupCustomReviews();
  checkForVariantId();
  addReadMore(); //Added by AM 2024-11-02
}

function addReadMore() {
  //check for a read more container
  const readMoreContainer = document.querySelector(".read-more-container");

  const insertBefore = (el, htmlString) =>
    el.insertAdjacentHTML("beforebegin", htmlString);
  const insertAfter = (el, htmlString) =>
    el.insertAdjacentHTML("afterend", htmlString);

  if (readMoreContainer != null) {
    //get a count of the child element

    if (readMoreContainer.children.length > 3) {
      //if more than 3, insert a read more and css hide the rest

      var childArray = Array.from(
        document.querySelector(".read-more-container").children
      );

      childArray.slice(3).forEach(function (child) {
        child.style.display = "none";
      });

      insertBefore(
        childArray[3],
        '<p class="read-more-link" style="test-align:center">Read More</p>'
      );
      insertAfter(
        childArray[childArray.length - 1],
        '<p class="read-less-link" style="display:none;text-aligh:center">Read Less</p>'
      );

      document.addEventListener("click", function (event) {
        if (event.target && event.target.classList.contains("read-more-link")) {
          //show hidden elements
          var childArray = Array.from(
            document.querySelector(".read-more-container").children
          );

          childArray.slice(3).forEach(function (child) {
            child.style.display = "block";
          });

          //hide read more
          event.target.style.display = "none";

          //show read less
          document.querySelector(".read-less-link").style.display = "block";
        }
      });

      document.addEventListener("click", function (event) {
        if (event.target && event.target.classList.contains("read-less-link")) {
          //show hidden elements
          var childArray = Array.from(
            document.querySelector(".read-more-container").children
          );

          childArray.slice(3).forEach(function (child) {
            child.style.display = "none";
          });

          //hide read less
          event.target.style.display = "none";
          //show read more

          document.querySelector(".read-more-link").style.display = "block";
        }
      });
    }
  }
}

function setupBannerDates() {
  const bannerDates = [...document.querySelectorAll("[js-banner-date]")];

  bannerDates.forEach((banner) => {
    const month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    let name = month[d.getMonth()];

    banner.innerText = `${name} Sale Now On`;
  });
}

function setupCustomAnnouncementBars() {
  const announcementCustomSwiper = new Swiper(".announcement-custom", {
    slidesPerView: 3,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      700: {
        slidesPerView: 3,
      },
    },
  });

  const announcementBarSwiper = new Swiper(".AnnouncementBar", {
    slidesPerView: 1,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      700: {
        slidesPerView: 3,
      },
    },
  });
}

function setupCustomReviews() {
  const reviewSwiper = new Swiper(".custom-reviews__swiper", {
    slidesPerView: "auto",
    loop: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

function checkForVariantId() {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  if (params.has("variant")) {
    params.delete("variant");
    url.search = params.toString();
    window.location.href = url.toString();
  }
}

$(document).ready(function ($) {
  const quickLinkMake = [
    ...document.querySelectorAll('[js-quick-link="make"]'),
  ];

  if (quickLinkMake) {
    quickLinkMake.forEach((linkMake) => {
      linkMake.addEventListener("click", (event) => {
        const carMake = event.target.innerText;
        const collectionListLink = document.querySelectorAll(
          "#collection-list-link"
        );

        if (!collectionListLink || !carMake) {
          return;
        }

        const pageOne = document.querySelector('[js-quick-links="pageOne"]');
        const pageTwo = document.querySelector('[js-quick-links="pageTwo"]');

        pageOne.scrollIntoView();

        collectionListLink.forEach((link) => {
          if (link.dataset.title.includes(carMake)) {
            if (pageOne) {
              pageOne.style.display = "none";
            }

            if (pageTwo) {
              pageTwo.style.display = "grid";
              const heading = document.querySelector(
                '[js-quick-link="heading"]'
              );
              const makeHeading = document.querySelector(
                '[js-quickLink="makeHeading"]'
              );
              const makeName = document.querySelector(
                '[js-quick-link="makeName"]'
              );

              if (heading) {
                heading.innerText = "Select the model";
              }

              if (makeHeading) {
                makeHeading.style.display = "flex";
              }
              if (makeName) {
                makeName.innerText = carMake;
              }

              let collectionLink = link.dataset.link;

              if (collectionLink.includes("volkswagen")) {
                if (!collectionLink.includes("vw-volkswagen")) {
                  return;
                }
              }

              const html = `<a href="${collectionLink}" class="car-collection-list__quick-link">${link.dataset.title}</a>`;
              pageTwo.insertAdjacentHTML("beforeend", html);
            }
          }
        });
      });
    });
  }

  const makeHeadingButton = document.querySelector(
    '[js-quickLink="makeHeading"]'
  );

  if (makeHeadingButton) {
    makeHeadingButton.addEventListener("click", () => {
      const pageOne = document.querySelector('[js-quick-links="pageOne"]');
      const pageTwo = document.querySelector('[js-quick-links="pageTwo"]');

      if (pageOne) {
        pageOne.style.display = "grid";
      }

      if (pageTwo) {
        pageTwo.style.display = "none";
        pageTwo.innerHTML = "";

        const heading = document.querySelector('[js-quick-link="heading"]');
        const makeHeading = document.querySelector(
          '[js-quickLink="makeHeading"]'
        );
        const makeName = document.querySelector('[js-quick-link="makeName"]');

        if (heading) {
          heading.innerText = "Select the make";
        }

        if (makeHeading) {
          makeHeading.style.display = "none";
        }
      }
    });
  }

  if ($(".template-product")[0]) {
    const accordionBtns = document.querySelectorAll(".faq__accordion");

    accordionBtns.forEach((accordion) => {
      accordion.onclick = function () {
        this.classList.toggle("is-open");

        let content = this.nextElementSibling;

        content.classList.toggle("is-open");

        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + 10 + "px";
        }
      };
    });

    hideNegativeReviews();

    setTimeout(() => {
      hideNegativeReviews();
    }, 750);

    setTimeout(() => {
      hideNegativeReviews();
    }, 1500);

    const reviewsIOButtons = [
      ...document.querySelectorAll(".R-PaginationControls__item"),
    ];

    if (reviewsIOButtons) {
      reviewsIOButtons.forEach((button) => {
        button.addEventListener("click", () => {
          hideNegativeReviews();

          setTimeout(() => {
            hideNegativeReviews();
          }, 1000);
        });
      });
    }

    function hideNegativeReviews() {
      waitForElm(".ElementsWidget-prefix").then((elm) => {
        const starRating = [
          ...document.querySelectorAll(".R-RatingStars__stars"),
        ];

        if (starRating) {
          starRating.forEach((rating) => {
            if (
              rating.title === "1 Stars" ||
              rating.title === "2 Stars" ||
              rating.title === "3 Stars"
            ) {
              const ratingContainer = rating.closest(".R-ContentList__item");

              if (ratingContainer) {
                ratingContainer.remove();
              }
            }
          });
        }
      });
    }

    const total = document.querySelector('[js-product-page="mainPrice"]');
    const clearPay = document.querySelector("afterpay-placement");

    if (clearPay && total) {
      clearPay.dataset.amount = total?.innerText.replace("£", "");
    }

    function waitForElm(selector) {
      return new Promise((resolve) => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver((mutations) => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    }

    waitForElm(".mw-apo-container").then((elm) => {
      const matQualityOptions = document.querySelector(".mat-quality-options");

      if (matQualityOptions) {
        const mwOptionValue = [
          ...matQualityOptions.querySelectorAll(".mw-option__value"),
        ];

        const productTitle = document.querySelector(
          '[js-product-meta="productTitle"]'
        ).innerText;
        const currentPrice = parseFloat(
          document
            .querySelector('[js-product-page="mainPrice"]')
            ?.innerText.replace("£", "")
        );
        const originalPrice = parseFloat(
          document
            .querySelector('[js-product-page="comparePrice"]')
            ?.innerText.replace("£", "")
        );

        let priceModifier = 0;

        if (!productTitle.toLowerCase().includes("van mats")) {
          priceModifier = 4;
        }

        mwOptionValue?.forEach((optionValue) => {
          const text = optionValue.querySelector(".mw-option__value-text");

          if (text.innerText.includes("ESSENTIAL")) {
            text.innerHTML = `ESSENTIAL - <span class="hulk-new-price">£${currentPrice}</span><del>£${originalPrice}</del>`;
            // text.parentElement.parentElement.insertAdjacentHTML('beforeend', '<img class="mw-custom-mat-swatch" src="//finestcarmats.co.uk/cdn/shop/files/comfort-1024x1024_d3e64aa3-2a03-4c4a-a292-5c139db5d24d_medium.jpg?v=1691608491" />');
            text.parentElement.insertAdjacentHTML(
              "beforeend",
              '<br><br><span class="dialogue">Straightforward and designed to last. Full protection for a reasonable price.</span><b class="hulk-option-freeshipping">Delivery only £3.99</b>'
            );
          }
          if (text.innerText.includes("COMFORT")) {
            text.innerHTML = `COMFORT - <span class="hulk-new-price">£${(
              currentPrice +
              18 -
              priceModifier
            ).toFixed(2)}</span><del>£${(
              originalPrice +
              15 -
              priceModifier
            ).toFixed(2)}</del>`;
            // text.parentElement.parentElement.insertAdjacentHTML('beforeend', '<img class="mw-custom-mat-swatch" src="https://finestcarmats.co.uk/cdn/shop/files/luxury-1024x1024_20c953e2-1f28-4172-81f4-02f423e5635e_medium.jpg?v=1691608491" />');
            text.parentElement.insertAdjacentHTML(
              "beforeend",
              '<br><br><span class="dialogue">Woven Velour & Soft Touch. This Is The First Step Into Luxury-Level Interior Protection.</span><b class="hulk-option-freeshipping">Free Delivery</b><span class="popular-tag">Most Popular</span>'
            );
          }
          if (text.innerText.includes("LONG LASTING RUBBER")) {
            text.innerHTML = `LONG LASTING RUBBER MATS - <span class="hulk-new-price">£${(
              currentPrice +
              23 -
              priceModifier
            ).toFixed(2)}</span><del>£${(
              originalPrice +
              32 -
              priceModifier
            ).toFixed(2)}</del>`;
            // text.parentElement.parentElement.insertAdjacentHTML('beforeend', '<img class="mw-custom-mat-swatch" src="https://finestcarmats.co.uk/cdn/shop/files/rubber-1024x1024_a10949a6-f712-4a17-9cd5-a3eca084a7b6_medium.jpg?v=1691608492" />');
            text.parentElement.insertAdjacentHTML(
              "beforeend",
              '<br><br><span class="dialogue">Built for all terrains and debris. Designed to battle all conditions with you and stand the test of time.</span><b class="hulk-option-freeshipping">Free Delivery</b>'
            );
          }
          if (text.innerText.includes("PREMIUM LASTING RUBBER")) {
            text.innerHTML = `PREMIUM LASTING RUBBER (5mm) - <span class="hulk-new-price">£${(
              currentPrice +
              29 -
              priceModifier
            ).toFixed(2)}</span><del>£${(
              originalPrice +
              38 -
              priceModifier
            ).toFixed(2)}</del>`;
            // text.parentElement.parentElement.insertAdjacentHTML('beforeend', '<img class="mw-custom-mat-swatch" src="https://finestcarmats.co.uk/cdn/shop/files/rubber-1024x1024_a10949a6-f712-4a17-9cd5-a3eca084a7b6_medium.jpg?v=1691608492" />');
            text.parentElement.insertAdjacentHTML(
              "beforeend",
              '<br><br><span class="dialogue">Our brand new Premium Lasting Rubber 5mm mats.</span><b class="hulk-option-freeshipping">Free Delivery</b>'
            );
          }
          if (text.innerText.includes("PRESTIGE")) {
            text.innerHTML = `PRESTIGE - <span class="hulk-new-price">£${(
              currentPrice +
              40 -
              priceModifier
            ).toFixed(2)}</span><del>£${(
              originalPrice +
              54 -
              priceModifier
            ).toFixed(2)}</del>`;
            // text.parentElement.parentElement.insertAdjacentHTML('beforeend', '<img class="mw-custom-mat-swatch" src="https://finestcarmats.co.uk/cdn/shop/files/deluxe-1024x1024_2effc3d2-1071-4f1d-b3f9-0fd3f5ea325c_medium.jpg?v=1691608492" />');
            text.parentElement.insertAdjacentHTML(
              "beforeend",
              '<br><br><span class="dialogue">A truly premium, woven velour finish. Don\'t be suprised when your passenger\'s ride with their shoes off.</span><b class="hulk-option-freeshipping">Free Delivery</b><!--b class="hulk-option-freeupgrade">UPGRADE TO SUPREME - FREE!</b-->'
            );
          }
          if (text.innerText.includes("SUPREME")) {
            text.innerHTML = `SUPREME - <span class="hulk-new-price">£${(
              currentPrice +
              64 -
              priceModifier
            ).toFixed(2)}</span><del>£${(
              originalPrice +
              104 -
              priceModifier
            ).toFixed(2)}</del>`;
            // text.parentElement.parentElement.insertAdjacentHTML('beforeend', '<img class="mw-custom-mat-swatch" src="https://finestcarmats.co.uk/cdn/shop/files/prestige-1024x1024_af485794-f177-44da-bc86-7bfd53b8f23c_medium.jpg?v=1691608492" />');
            text.parentElement.insertAdjacentHTML(
              "beforeend",
              '<br><br><span class="dialogue">Thick, twisted velour composure. Good enough to be laid in your house as a carpet.</span><b class="hulk-option-freeshipping">Free Delivery</b>'
            );
          }

          if (text.innerText.includes("OPULENCE")) {
            text.innerHTML = `OPULENCE  - <span class="hulk-new-price">£${(
              currentPrice +
              80 -
              priceModifier
            ).toFixed(2)}</span><del>£${(
              originalPrice +
              125 -
              priceModifier
            ).toFixed(2)}</del>`;
            // text.parentElement.parentElement.insertAdjacentHTML('beforeend', '<img class="mw-custom-mat-swatch" src="https://finestcarmats.co.uk/cdn/shop/files/prestige-1024x1024_af485794-f177-44da-bc86-7bfd53b8f23c_medium.jpg?v=1691608492" />');
            text.parentElement.insertAdjacentHTML(
              "beforeend",
              '<br><br><span class="dialogue">Crafted with thick, luxurious twisted velour that exudes premium quality. So refined and plush, it’s fit to grace your home as elegantly as your car.</span><b class="hulk-option-freeshipping">Free Delivery</b>'
            );
          }
        });

        const options = [
          ...document.querySelectorAll(".mw-option:not(.mw-hidden)"),
        ];

        options.forEach((option, index) => {
          const heading = option.querySelector(
            ".mw-text.mw-text--style-strong"
          );

          if (heading) {
            const newInnerHtml = `<span class="mw-step-index">${
              index + 1
            }.</span> ${heading.innerHTML}`;

            heading.innerHTML = newInnerHtml;
          }
        });
      }

      const addToCartButton = document.querySelector(
        ".mw-apo-add-to-cart-cloned"
      );

      if (addToCartButton) {
        addToCartButton.innerText = "CHECKOUT NOW";
        addToCartButton.style.display = "flex";
      }

      const productTitle = document.querySelector(
        '[js-product-meta="productTitle"]'
      );

      if (productTitle?.innerText.toLowerCase().includes("boot")) {
        const matLogo = document.querySelector(".mat-logo");

        if (matLogo) {
          matLogo.style.display = "none";
        }
      }
    });

    jQuery(document).on("change", ".mw-option__control", function (event) {
      setTimeout(function () {
        const addToCartButtonChange = document.querySelector(
          ".mw-apo-add-to-cart-cloned"
        );
        const total = document.querySelector(".mw-apo-add-to-cart-hide");

        if (total) {
          const totalAmount = total.innerText;
          const totalAmountFormattedNumber = Number(
            totalAmount.replace(/[^0-9\.]+/g, "")
          );

          let buttonMessage = "CHECKOUT NOW - " + total.innerText;

          if (totalAmountFormattedNumber > 30) {
            buttonMessage =
              "CHECKOUT NOW <br>" + total.innerText + " + FREE SHIPPING 🎉";
          }

          addToCartButtonChange.innerHTML = buttonMessage;
        }

        const productTitle = document.querySelector(
          '[js-product-meta="productTitle"]'
        );

        if (productTitle?.innerText.toLowerCase().includes("boot")) {
          const matLogo = document.querySelector(".mat-logo");

          if (matLogo) {
            matLogo.style.display = "none";
          }
        }

        const clearPay = document.querySelector("afterpay-placement");

        if (clearPay && total) {
          clearPay.dataset.amount = total?.innerText.replace("£", "");
        }

        const bootMatOptionsSection = [
          ...document.querySelectorAll(".boot-mat-add-on"),
        ];

        if (bootMatOptionsSection[0]) {
          let bootMatValueId;
          let matQualityChosen = false;

          switch (event.target.value) {
            case "v_3662077":
              bootMatValueId = "v_3845559";
              matQualityChosen = true;
              break;
            case "v_3662078":
              bootMatValueId = "v_620747_lbe4kfzf";
              matQualityChosen = true;
              break;
            case "v_3662079":
              bootMatValueId = "v_620747_lbe4jz4q";
              matQualityChosen = true;
              break;
            case "v_3662080":
              bootMatValueId = "v_620747_lbe4kzf6";
              matQualityChosen = true;
              break;
            case "v_3662081":
              bootMatValueId = "v_620747_lbe4l5gh";
              matQualityChosen = true;
              break;
          }

          if (matQualityChosen) {
            const currentUrl = window.location.href;

            if (currentUrl.includes("-car-mats")) {
              const bootMatUrl = currentUrl.replace("-car-mats", "-boot-mat");

              fetch(bootMatUrl)
                .then((response) => {
                  const bootMatOptionsSection = [
                    ...document.querySelectorAll(".boot-mat-add-on"),
                  ];

                  if (response.status === 200 && bootMatOptionsSection[0]) {
                    bootMatOptionsSection[0].style.display = "block";
                  }
                })
                .catch((error) => {
                  console.error(error);
                });
            }
          }

          if (bootMatValueId) {
            const bootMatOption = bootMatOptionsSection[0].querySelector(
              `[data-value-id="${bootMatValueId}"]`
            );
            const bootMatOptions = [
              ...bootMatOptionsSection[0].querySelectorAll(".mw-option__value"),
            ];

            if (bootMatOptions) {
              bootMatOptions.forEach((option) => {
                option.style.display = "none";
              });
            }

            if (bootMatOption) {
              bootMatOption.style.display = "block";
            }
          }
        }

        const visibleOptions = [
          ...document.querySelectorAll(".mw-option:not(.mw-hidden)"),
        ];

        visibleOptions.forEach((option, index) => {
          const heading = option.querySelector(
            ".mw-text.mw-text--style-strong"
          );

          if (heading) {
            const stepIndex = heading.querySelector(".mw-step-index");

            if (stepIndex) {
              stepIndex.remove();
            }

            const newInnerHtml = `<span class="mw-step-index">${
              index + 1
            }.</span> ${heading.innerHTML}`;

            heading.innerHTML = newInnerHtml;
          }
        });

        const currentEventTarget = event.target;
        const matQualityTypeOption = event.target.closest(
          ".mat-quality-options"
        );

        if (currentEventTarget && matQualityTypeOption) {
          const mwOption = currentEventTarget.closest(".mw-option");
          const mwContainer = currentEventTarget.closest(".mw-apo-container");

          if (mwOption && mwContainer) {
            const mwOptions = [...document.querySelectorAll(".mw-option")];

            const currentOptionIndex = mwOptions.findIndex(
              (option) => option.id === mwOption.id
            );

            let nextOption;

            mwOptions.forEach((option, index) => {
              if (index > currentOptionIndex && !nextOption) {
                if (!option.classList.contains("mw-hidden")) {
                  nextOption = option;
                }
              }
            });

            if (nextOption) {
              nextOption.scrollIntoView({ behavior: "smooth" });
            }
          }
        }
      }, 1000);
    });

    jQuery(".material-type").hide();

    jQuery(".Product__SlideshowNavScroller .is-selected").appendTo(
      ".Product__SlideshowNavScroller"
    );

    jQuery(".Product__SlideshowNavScroller .is-selected").removeClass(
      "is-selected"
    );

    jQuery(".Product__SlideshowNavScroller a:nth-of-type(1) img").trigger(
      "click"
    );

    setTimeout(function () {
      jQuery(".Product__Slideshow").removeClass("hidden-img");
      jQuery(".material-type").show();
    }, 2500);

    $(".overwrite-list:first p").each(function () {
      $(this).replaceWith(
        "<li><img src='https://cdn.shopify.com/s/files/1/0576/1997/2211/files/circle_green_checkmark.svg?v=1662637633'>" +
          $(this).html() +
          "</li>"
      );
    });

    if ($(window).width() > 1000) {
      $("#shopify-block-6ec62c65-69fb-437a-824b-1c34232136f1").insertAfter(
        ".Product__SlideshowNav"
      );
    } else {
      $("#shopify-block-6ec62c65-69fb-437a-824b-1c34232136f1").insertAfter(
        ".ProductForm"
      );
    }

    $(window).resize(function () {
      if ($(window).width() > 1000) {
        $("#shopify-block-6ec62c65-69fb-437a-824b-1c34232136f1").insertAfter(
          ".Product__SlideshowNav"
        );
      } else {
        $("#shopify-block-6ec62c65-69fb-437a-824b-1c34232136f1").insertAfter(
          ".ProductForm"
        );
      }
    });

    var time_hulk = setInterval(function () {
      // $('.radio_div, .hulkapps_option_name').each(function () {
      //   var value = $(this)
      //   .clone()    //clone the element
      //   .children() //select all the children
      //   .remove()   //remove all the children
      //   .end()  //again go back to selected element
      //   .text();
      //   var value = value.toLowerCase().replace(/\b[a-z]/g, function(letter) {
      //   return letter.toUpperCase();
      //   });
      //   $(this).contents().get(0).nodeValue = value;
      // });
      //   $('.hulkapps_option_set > div .hulkapps_option_name:visible').each(function(index, value) {
      //   var counter = index + 1;
      //   if(! $(this).find('.hulkapps_number')[0]) {
      //   $(this).html('<span class="hulkapps_number">' + counter + '</span>' + $(this).html());
      //     clearInterval(time_hulk);
      //   }
      // });
    }, 100);
  }

  $('#car-list p[target="VW"]').text("Volkswagen").attr("target", "Volkswagen");

  var mylist = $("#car-list");

  var listitems = mylist.children("p").get();

  listitems.sort(function (a, b) {
    return $(a).text().toUpperCase().localeCompare($(b).text().toUpperCase());
  });

  $.each(listitems, function (idx, itm) {
    mylist.append(itm);
  });

  $("#car-list p").each(function (i, v) {
    var targetName = $(this).attr("target");
    $("#car-list p[target='" + targetName + "']:not(:first)").remove();
  });

  var car_array = [];
  var car_model_array = [];

  $(document)
    .find("#car-list p")
    .each(function () {
      if ($(this).attr("target").length > 1) {
        var last_element = car_array[car_array.length - 1];

        if (last_element) {
          if ($(this).attr("target").includes(last_element)) {
            car_model_array.push($(this).attr("target"));
          } else {
            car_array.push($(this).attr("target"));
          }
        } else {
          car_array.push($(this).attr("target"));
        }
      }
    });

  jQuery.each(car_array, function (index, item) {
    jQuery.each(car_model_array, function (index2, item2) {
      if (item2.includes(item)) {
        $(
          '<option class="ajax-option" value="' +
            item +
            '">' +
            item +
            "</option>"
        ).appendTo("#car-manufacturer");
        return false;
      }
    });
  });

  let carManufacturer = "";
  let carModel = "";

  $(document).on("change", "#car-manufacturer", function () {
    var selected = $(this).val();
    carManufacturer = selected;

    $("#car-model").find(".ajax-option").remove();
    $("#car-model").val("");

    if (selected) {
      jQuery.each(car_model_array, function (index, item) {
        if (item.includes(selected)) {
          $(
            '<option class="ajax-option" value="' +
              item +
              '">' +
              item +
              "</option>"
          ).appendTo("#car-model");
        }
      });
    }
  });

  $(document).on("change", "#car-model", function () {
    var modelSelected = $(this).val();

    carModel = modelSelected.replace(carManufacturer, "").trim();
  });

  $(document).on("click", "#car-mat-submit", function () {
    let submissionManufacturer = carManufacturer;
    if (carManufacturer.includes("Range Rover")) {
      submissionManufacturer = "Land-Rover-Range-Rover";
    }
    if (carManufacturer.includes("Volkswagen")) {
      submissionManufacturer = "VW Volkswagen";
    }

    // const formattedCarModel = carModel.replaceAll(' & ', '-').replaceAll(' ', '-');
    const formattedCarModel = carModel.replace(/[ &.]+/g, "-");

    $.get(
      `https://finestcarmats.co.uk/collections/${submissionManufacturer.replace(
        " ",
        "-"
      )}-${formattedCarModel}-car-mats`,
      function (data) {
        const html = $(data);
        const products = html.find(".CollectionMain").html();

        $(".products").html(products);
      }
    ).fail(function () {
      $(".vehicle-reg-checker__error").html(
        `There was a problem finding your mats`
      );
      nodeSelectors.error.style.display = "block";
    });
  });

  const cartCtaNodeSelector = [
    ...document.querySelectorAll('[js-product-item="cartCta"]'),
  ];

  cartCtaNodeSelector.forEach((element) => {
    element.addEventListener("click", (event) => {
      const id = event.target.dataset.id;

      if (!id) {
        return;
      }

      const formData = {
        items: [
          {
            id: id,
            quantity: 1,
          },
        ],
      };

      fetch("cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  });

  const selectors = {
    input: '[js-vehicle-reg="inputField"]',
    error: '[js-vehicle-reg="error"]',
    button: '[js-vehicle-reg="submitButton"]',
    carData: '[js-vehicle-reg="carInfo"]',
    products: '[js-vehicle-reg="products"]',
    or: '[js-vehicle-checker="or"]',
    carMatFilterHeader: '[js-car-mat-filter="header"]',
    carMatFilterSection: '[js-car-mat-filter="section"]',
  };

  const nodeSelectors = {
    input: document.querySelector(selectors.input),
    error: document.querySelector(selectors.error),
    button: document.querySelector(selectors.button),
    carData: document.querySelector(selectors.carData),
    products: document.querySelector(selectors.products),
    or: document.querySelector(selectors.or),
    carMatFilterHeader: document.querySelector(selectors.carMatFilterHeader),
    carMatFilterSection: document.querySelector(selectors.carMatFilterSection),
  };

  if (!nodeSelectors.input && !nodeSelectors.button) {
    return;
  }

  nodeSelectors.button.addEventListener("click", (event) => {
    if (nodeSelectors.input.value) {
      submitReg(event);
      event.target.disabled = true;

      setTimeout(function () {
        event.target.disabled = false;
      }, 5000);
    }
  });

  nodeSelectors.input.addEventListener("input", (event) => {
    const disabledBool = event.target.value.length > 0 ? false : true;
    nodeSelectors.button.disabled = disabledBool;
  });

  function submitReg(event) {
    if (!nodeSelectors.input.value) {
      return;
    }

    const reg = nodeSelectors.input.value;

    const carDataAPI = `https://proxy.cors.sh/https://api.vehiclesmart.com/rest/vehicleData?reg=${reg}&extendedMode=false&appid=FinestCarMats-hbYhwgmpa3pGz3CAVEnp`;
    // const carDataAPI = `https://api.vehiclesmart.com/rest/vehicleData?reg=${reg}&extendedMode=false&appid=FinestCarMats-hbYhwgmpa3pGz3CAVEnp`
    // const carDataAPI = `https://api.vehiclesmart.com/rest/vehicleData?reg=${reg}&extendedMode=false&appid=FinestCarMats-hbYhwgmpa3pGz3CAVEnp`

    fetch(carDataAPI, {
      headers: {
        "x-cors-api-key":
          "live_1ba202fca4c647e577e25d2604690d600d61df70a01b787833f933251655eb08",
      },
    })
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        renderProducts(result);
      })
      .catch((error) => {
        console.error(error);

        if (nodeSelectors.error) {
          nodeSelectors.error.style.display = "block";
        }
      });
  }

  function renderProducts(data) {
    if (!nodeSelectors.products || !data) {
      return;
    }

    const success = data.Success;
    const serviceMessage = data.ServiceMessage;

    nodeSelectors.error.style.display = "none";

    if (!success && serviceMessage) {
      $(".vehicle-reg-checker__error").html(
        `There was a problem finding your mats by car registration:<br><b>${serviceMessage.replace(
          "To access MOT and tax data please email info@vehiclesmart.com",
          "Please use the dropdowns below or email info@finestcarmats.co.uk"
        )}</b>`
      );
      nodeSelectors.error.style.display = "block";
      return;
    }

    const carMake = data.VehicleDetails.Make.replace("-BENZ", "").replace(
      "VOLKSWAGEN",
      "VW-VOLKSWAGEN"
    );
    let carModel = data.VehicleDetails.Model.replace(
      "GRAND SCENIC",
      "SCENIC"
    ).replace("RANGE ROVER EVOQUE S D AUTO", "RANGE ROVER EVOQUE");
    const carYear = parseInt(data.VehicleDetails.Year);

    if (nodeSelectors.carData) {
      nodeSelectors.carData.style.display = "block";
      nodeSelectors.carData.innerHTML = `You have a <br> ${carMake} ${carModel} ${carYear} ${data.VehicleDetails.FuelDvsa}`;
    }

    if (carMake === "MERCEDES") {
      if (
        carModel === "A" ||
        carModel === "B" ||
        carModel === "C" ||
        carModel === "E" ||
        carModel === "R" ||
        carModel === "V"
      ) {
        carModel = data.VehicleDetails.Model + "-class";
      }
    }

    const collectionUrl = `https://finestcarmats.co.uk/collections/${carMake.replaceAll(" ", "-").replaceAll("%20", "-")}-${carModel.replaceAll(" ", "-").replaceAll("%20", "-")}-car-mats`; 
    console.log('collectionbm:'+collectionUrl);

    const collectionUrlFallback = `https://finestcarmats.co.uk/collections/${carMake.replaceAll(" ", "-").replaceAll("%20", "-")}-car-mats`; 
    console.log('collectionbf:'+collectionUrlFallback);

    $.get(collectionUrl, function (data) {
      const html = $(data);
      const products = html.find(".CollectionMain").html();

      $(".products").html(products);

      const productTitles = [
        ...document.querySelectorAll(".ProductItem__Title.Heading"),
      ];

      productTitles.forEach((title) => {
        const titleText = title.querySelector("a").innerText;
        const splitYears = titleText
          .substring(titleText.indexOf("(") + 1, titleText.lastIndexOf(")"))
          .split("-");

        const lowerYear = parseInt(splitYears[0]);
        const higherYear = parseInt(splitYears[1]);

        if (carYear > higherYear || carYear < lowerYear) {
          const productCard = title.closest(".Grid__Cell");
          productCard.remove();
        }
      });

      if (nodeSelectors.carMatFilterSection) {
        nodeSelectors.carMatFilterSection.style.display = "none";
      }

      if (nodeSelectors.carMatFilterHeader) {
        nodeSelectors.carMatFilterHeader.style.display = "none";
      }

      if (nodeSelectors.or) {
        nodeSelectors.or.style.display = "none";
      }
    }).fail(function () {
      // fallback - redirecting to brand collection
      console.log('fallback');
      window.location.href = collectionUrlFallback;
      /*$.get(collectionUrlFallback, function (data) {
         
        const html = $(data);
        const products = html.find(".CollectionMain").html();
        $(".products").html(products);
  
        const productTitles = [
          ...document.querySelectorAll(".ProductItem__Title.Heading"),
        ];
  
        productTitles.forEach((title) => {
          const titleText = title.querySelector("a").innerText;
          const splitYears = titleText
            .substring(titleText.indexOf("(") + 1, titleText.lastIndexOf(")"))
            .split("-");
  
          const lowerYear = parseInt(splitYears[0]);
          const higherYear = parseInt(splitYears[1]);
  
          if (carYear > higherYear || carYear < lowerYear) {
            const productCard = title.closest(".Grid__Cell");
            productCard.remove();
          }
        });
  
        if (nodeSelectors.carMatFilterSection) {
          nodeSelectors.carMatFilterSection.style.display = "none";
        }
  
        if (nodeSelectors.carMatFilterHeader) {
          nodeSelectors.carMatFilterHeader.style.display = "none";
        }
  
        if (nodeSelectors.or) {
          nodeSelectors.or.style.display = "none";
        }
      }).fail(function () {
        $(".vehicle-reg-checker__error").html(
          `There was a problem finding your mats by car registration:<br><b>Please try the make/model form below</b>`
        );
        nodeSelectors.error.style.display = "block";
      });*/

      // end fallback
      /*$(".vehicle-reg-checker__error").html(
        `There was a problem finding your mats by car registration:<br><b>Please try the make/model form below</b>`
      );
      nodeSelectors.error.style.display = "block"; */
      
    });
  }
});
